import React from "react";
import "./summary.css";
import Header from "../../../component/header";
import SideNav from "../../../component/sideNav";
import SummaryDetail from "./summaryDetail";

export default function Summary() {
  return (
    <div className="summaryContainer">
      <Header></Header>
      <SideNav active="Dashboard" />
      <div className="summaryContent">
        <SummaryDetail></SummaryDetail>
      </div>
    </div>
  );
}
